export const SET_AUTH_PROPERTY = 'SET_AUTH_PROPERTY';
export const POST_LOGIN_IDENTITY = 'POST_LOGIN_IDENTITY';
export const GET_LOGIN_ENTRAID = 'GET_LOGIN_ENTRAID';
export const GET_LOGOUT = 'GET_LOGOUT';
export const SET_USER_INFO = 'SET_USER_INFO';
export const RESTORE_SESSION = 'RESTORE_SESSION';
export const GET_USER_INFO = 'GET_USER_INFO';
export const POST_USER_SESSION = 'POST_USER_SESSION';
